import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const processSteps = [{
  title: "Thorough Inspection",
  description: "We conduct a detailed assessment of your property to identify pest activity, entry points, and potential risk areas."
}, {
  title: "Customized Plan",
  description: "Based on our findings, we develop a targeted treatment strategy tailored specifically to your home and pest issues."
}, {
  title: "Targeted Treatment",
  description: "Our licensed technicians apply safe, effective solutions to eliminate current infestations and create a protective barrier."
}, {
  title: "Ongoing Protection",
  description: "We provide continuous monitoring and regular maintenance to ensure your property remains pest-free year-round."
}];
export default function PestControlProcess() {
  return <section id="pestcontrolprocess" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Our Proven 4-Step Process
          </h2>
          <p className="font-serif text-lg text-muted-foreground max-w-2xl mx-auto">
            We take a systematic approach to ensure your home is completely protected from pests, termites, and mosquitoes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
          {processSteps.map((step, index) => <div key={index} data-index={index} className="relative flex flex-col">
              <Card className="flex-1 rounded-none border-border shadow-sm bg-card relative z-10">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center mb-4 shadow-sm">
                    <span className="font-default text-primary-foreground text-xl font-bold">
                      {index + 1}
                    </span>
                  </div>
                  <CardTitle className="font-default text-xl text-card-foreground">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="font-serif text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </CardContent>
              </Card>

              {}
              {index < processSteps.length - 1 && <div className="hidden md:flex absolute top-1/2 -right-6 w-12 h-12 -translate-y-1/2 items-center justify-center z-20 pointer-events-none">
                  <ArrowRight className="w-8 h-8 text-muted-foreground/50" />
                </div>}
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-default text-lg px-8 py-6 shadow-md">
            <Link to="/ContactPage">
              Get A Free Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}